import { getQueryParam, setQueryParam } from "./queryParams";

const ORG_NODE_STORAGE_KEY = "orgNode";

function getOrgNodeShareable(): string | null {
  const fromUrl = getQueryParam(ORG_NODE_STORAGE_KEY);
  if (fromUrl !== null && fromUrl.trim() !== "") {
    return fromUrl.trim();
  }

  const fromLs = localStorage.getItem(ORG_NODE_STORAGE_KEY);
  if (fromLs !== null && fromLs.trim() !== "") {
    return fromLs.trim();
  }

  return null;
}

export function getShareableSetting(key: string): string | null {
  if (key === ORG_NODE_STORAGE_KEY) {
    return getOrgNodeShareable();
  }

  return getQueryParam(key) ?? localStorage.getItem(key);
}

export function decodeShareableSetting<T>(
  key: string,
  decoder: (encoded: string | null) => T | undefined,
): T | undefined {
  return decoder(getQueryParam(key)) ?? decoder(localStorage.getItem(key));
}

export function encodeShareableSetting<T>(
  key: string,
  value: T,
  encoder: (value: T) => string,
): void {
  const encoded = encoder(value);
  setShareableSetting(key, encoded);
}

export function setShareableSetting(key: string, value: string): void {
  if (key === ORG_NODE_STORAGE_KEY && value.trim() === "") {
    return;
  }
  setQueryParam(key, value);
  localStorage.setItem(key, value);
}
